import axios from 'axios';

const authClient = axios.create({
  baseURL: import.meta.env.VITE_API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

export interface LoginCredentials {
  email: string;
  password: string;
}

export interface LoginResponse {
  accessToken: string;
  expiresIn: number;
  type: string;
}

export async function loginRequest(credentials: LoginCredentials): Promise<LoginResponse> {
  const { data } = await authClient.post<LoginResponse>('/auth/login', credentials);
  return data;
}

export async function logoutRequest(): Promise<void> {
  const accessToken = localStorage.getItem('accessToken');
  await authClient.post(
    '/auth/logout',
    null,
    accessToken ? { headers: { Authorization: `Bearer ${accessToken}` } } : undefined
  );
}
